export enum SearchFilterDayTimeType {
  ALL = 'all',
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
}

export const SearchFilterDayTimeMap: Record<SearchFilterDayTimeType, string> = {
  [SearchFilterDayTimeType.ALL]: 'Todos',
  [SearchFilterDayTimeType.MORNING]: 'Manhã',
  [SearchFilterDayTimeType.AFTERNOON]: 'Tarde',
};

export const searchFilterDayTimeOptions: SearchFilterDayTimeType[] = [
  SearchFilterDayTimeType.ALL,
  SearchFilterDayTimeType.MORNING,
  SearchFilterDayTimeType.AFTERNOON,
];

export const DAY_TIME_ANALYTICS_KEY = 'periodo_do_dia';

export const SearchFilterDayTimeAnalyticsMap: Record<SearchFilterDayTimeType, string> = {
  [SearchFilterDayTimeType.ALL]: 'todos',
  [SearchFilterDayTimeType.MORNING]: 'manha',
  [SearchFilterDayTimeType.AFTERNOON]: 'tarde',
};
